var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInventoryFilled = function SvgInventoryFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M3.9 3.25c-.902 0-1.65.725-1.65 1.639V6.36C2.25 7.275 2.998 8 3.9 8h16.2c.902 0 1.65-.725 1.65-1.639V4.89c0-.914-.748-1.639-1.65-1.639H3.9Zm-.45 15.01V9h17.1v9.26c0 1.402-1.148 2.49-2.55 2.49H6c-1.402 0-2.55-1.088-2.55-2.49Zm5.088-7.183c0-.382.31-.692.693-.692h5.538a.692.692 0 1 1 0 1.384H9.231a.692.692 0 0 1-.693-.692Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInventoryFilled);
export default ForwardRef;